<template>
  <v-card flat>
    <v-list dense>
      <template v-for="item in items">
        <v-list-group
          v-if="item.children"
          :key="item.text"
          v-model="item.active"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.route"
            :href="child.href"
            :target="child.route ? '_self' : '_blank'"
            :class="[
              {
                'router-link-active--false': child.route && activeMenu != child.route.name,
              },
              {
                'v-list-item--active': child.route && activeMenu == child.route.name,
              },
            ]"
          >
            <v-list-item-content>
              <v-list-item-title v-text="child.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-else
          :key="item.text"
          v-model="item.active"
          link
          :to="item.route"
          :class="{
            'router-link-active--false': item.route && activeMenu != item.route.name,
          }"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      items: [
        {
          icon: 'mdi-login-variant',
          active: false,
          text: '로그인 / 회원가입',
          route: { path: '/signin' },
        },
        {
          icon: 'mdi-home',
          active: false,
          text: '홈으로',
          route: { path: '/' },
        },
        // {
        //   icon: 'mdi-information-outline',
        //   active: false,
        //   text: '회사 소개',
        //   route: { path: '/aboutus' },
        // },
        // {
        //   icon: 'mdi-information-outline',
        //   active: false,
        //   text: '공지사항',
        //   route: { path: '/notice' },
        // },
      ],
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    activeMenu() {
      const name = this.$route.name
      if (name == null) {
        return ''
      }

      // this.$route.matched[0] : parent 라우터 또는 자기 자신
      const firstMatchedRouter = this.$router.options.routes.filter((router) => {
        return router.path === this.$route.matched[0].path
      })[0]

      return firstMatchedRouter ? firstMatchedRouter.name : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.router-link-active--false {
  color: $black;
  &::before {
    opacity: 0;
  }
}
</style>
